import React from 'react';
import { ButtonItem } from '@atlaskit/menu';
import { RouterActions } from '@atlassian/react-resource-router';
import { useIntl } from '@atlassian/jira-intl';
import { useRovoEntitlement } from '@atlassian/conversation-assistant-entitlement';
import { useBoardSelector } from '../../../../../../../state/index.tsx';
import {
	getCardTransitions,
	getColumnEntity,
	projectKeySelector,
} from '../../../../../../../state/selectors/software/software-selectors.tsx';
import { firstIssueTypeIdSelector } from '../../../../../../../state/selectors/issue-type/issue-type-selectors.tsx';
import { useCapability } from '../../../../../../../state/state-hooks/capabilities/index.tsx';
import { Capability } from '../../../../../../../common/capability/index.tsx';
import { findTransition, getFirstStatusId, getWorkflowUrlForAgentRule } from './utils.tsx';

import messages from './messages.tsx';

export const ColumnAddAgentItem = ({
	columnId,
	isDisabled,
}: {
	columnId: number;
	isDisabled: boolean;
}) => {
	const projectKey = useBoardSelector(projectKeySelector);
	const issueTypeId = useBoardSelector(firstIssueTypeIdSelector);
	const transitions = useBoardSelector(getCardTransitions);
	const columnIdAsString = columnId.toString();
	const columnEntity = useBoardSelector(getColumnEntity)[columnIdAsString];
	const isRovoEnabled = useRovoEntitlement();
	// this is for TMP edit workflow permissions, won't show on CMP for demo
	const hasWorkflowPermissions = useCapability(Capability.RENDER_MANAGE_WORKFLOW_MENU_ITEM);

	const statusId = getFirstStatusId(columnEntity);
	const transitionId =
		issueTypeId && statusId
			? findTransition({
					transitions: transitions.columnIssueTypeTransitions,
					columnId: columnIdAsString,
					issueTypeId,
					statusId,
				})
			: undefined;

	const { formatMessage } = useIntl();

	if (hasWorkflowPermissions && isRovoEnabled && issueTypeId && transitionId) {
		return (
			<RouterActions>
				{({ push }) => {
					const onClick = () =>
						push(getWorkflowUrlForAgentRule({ projectKey, issueTypeId, transitionId }));

					return (
						<ButtonItem role="menuitem" isDisabled={isDisabled} onClick={onClick}>
							{formatMessage(messages.displayText)}
						</ButtonItem>
					);
				}}
			</RouterActions>
		);
	}

	return null;
};
